import { createSelector } from 'reselect';
import { DOMAIN_NAME } from './common';

const selectKpiTemplateDomain = state => state[DOMAIN_NAME] || {};

export const selectTemplates = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.templates || []
);

export const selectAllGoals = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.allGoals || []
);

export const selectDepartments = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.departments || []
);

export const selectCurrentTemplate = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.currentTemplate
);

export const selectCurrentTemplateGoals = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.currentTemplateGoals || []
);

export const selectLoading = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.loading || false
);

export const selectGoalsLoading = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.goalsLoading || false
);

export const selectPagination = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.pagination || { limit: 10, offset: 1, total: 0 }
);

export const selectFilters = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.filters || { search: '' }
);

export const selectSort = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.sort || { sortBy: 'createdAt', sortDescending: true }
);

export const selectDialogs = createSelector(
    [selectKpiTemplateDomain],
    domain => domain.dialogs || {}
);

export const selectTemplateDialog = createSelector(
    [selectDialogs],
    dialogs => dialogs.template || { open: false, data: null }
);

export const selectGoalDialog = createSelector(
    [selectDialogs],
    dialogs => dialogs.goal || { open: false, data: null }
);

export const selectManageGoalsDialog = createSelector(
    [selectDialogs],
    dialogs => dialogs.manageGoals || { open: false, template: null }
);

export const selectDeleteDialog = createSelector(
    [selectDialogs],
    dialogs => dialogs.delete || { open: false, template: null }
);

export const selectDeleteGoalDialog = createSelector(
    [selectDialogs],
    dialogs => dialogs.deleteGoal || { open: false, goalId: null }
);
